/**
 * Swatch King (variant-swatch-king, an @app block) renders the Size
 * option's swatch legend asynchronously and can re-render it on variant
 * changes, so the Ring Size Guide trigger (rendered by
 * snippets/sidebar-trigger.liquid in sections/main-product.liquid) is moved
 * into that legend here instead of being authored inside the app's markup.
 */
const trigger = document.querySelector('.sidebar-trigger--pending[aria-controls="RingSizeGuide"]');
const productInfo = document.querySelector('.wt-product__info');

if (trigger && productInfo) {
  const insertTrigger = () => {
    const legend = document.getElementById('option3')?.closest('legend');
    if (legend && !legend.contains(trigger)) {
      legend.appendChild(trigger);
      trigger.classList.remove('sidebar-trigger--pending');
    }
  };

  insertTrigger();

  new MutationObserver(insertTrigger).observe(productInfo, {
    childList: true,
    subtree: true,
  });
}
